import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { DatiFirmaVO } from "@app/shared/vo/dati-firmaVO";
import { MapperInfoCertificato } from "@app/shared/mapper/edocumento/mapper-info-certificato";
import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";
import { MapperInfoFirma } from "@app/shared/mapper/edocumento/mapper-info-firma";
import { DatiFirmaDTO } from "../dto/dati-firmaDTO";
import { MapperUtente } from "./mapper-utente";

@Injectable({
  providedIn: "root",
})
export class MapperDatiFirma
  implements MapperInterface<DatiFirmaDTO, DatiFirmaVO> {
  constructor(
    private mapperInfoCertificato: MapperInfoCertificato,
    private mapperInfoFirma: MapperInfoFirma,
    private mapperUtente: MapperUtente
  ) {}

  convertVoToDto(e: DatiFirmaVO): DatiFirmaDTO {
    const datiFirmaDto = new DatiFirmaDTO();

    datiFirmaDto.dataVerifica = e.dataVerifica;
    datiFirmaDto.statoVerifica = e.statoVerifica;
    datiFirmaDto.firmatario = this.mapperUtente.convertVoToDto(e.firmatario);
    datiFirmaDto.info = this.mapperInfoFirma.convertListVoToDto(e.info);

    return datiFirmaDto || new DatiFirmaDTO();
  }
  convertDtoToVo(t: DatiFirmaDTO): DatiFirmaVO {
    console.log("MapperDatiFirma", t);
    const datiFirmaVo = new DatiFirmaVO();
    if (t.firmatario !== null) {
      datiFirmaVo.firmatario = this.mapperUtente.convertDtoToVo(t.firmatario);
    }
    datiFirmaVo.dataVerifica = t.dataVerifica;
    datiFirmaVo.statoVerifica = t.statoVerifica;
    datiFirmaVo.info = this.mapperInfoFirma.convertListDtoToVo(t.info);

    return datiFirmaVo || new DatiFirmaVO();
  }
  convertListVoToDto(e: DatiFirmaVO[]): DatiFirmaDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(datiFirmaDTO: DatiFirmaDTO[]): DatiFirmaVO[] {
    console.log(
      "[MapperDatiFirma] DatiFirmaDTOList => DatiFirmaDTOList",
      datiFirmaDTO
    );
    const datiFirmaVO = new Array<DatiFirmaVO>();
    const infoCertificatoVO = new Array<InfoCertificatoVO>();

    datiFirmaDTO.forEach((element) => {
      const datoFirmaVO = new DatiFirmaVO();
      datoFirmaVO.dataVerifica = element.dataVerifica;
      datoFirmaVO.info = this.mapperInfoFirma.convertListDtoToVo(element.info);
      datiFirmaVO.push(datoFirmaVO);
    });

    return datiFirmaVO || new Array<DatiFirmaVO>();
  }
}
